import { useQuery } from "@tanstack/react-query";
import { apiUrls } from "src/consts/ApiUrls";
import useMyUser from "./useMyUser";
import { portalApiClient } from "../apiClient";
import { useParams } from "react-router-dom";
import { LocalStorageKeys } from "src/utils/localStorageKeys";

export function useCompletionsForNearestWeek() {
  const {data: myUser} = useMyUser();
  const {companyId} = useParams();
  const query = useQuery({
    queryKey: ["completionsForNearestWeek"],
    queryFn: async () => {
      const today = new Date();
      today.setHours(0, 0, 0, 0); // Set to start of day
      
      const startDate = new Date(today);
      startDate.setDate(startDate.getDate() - 7); // 7 days prior
      
      const endDate = new Date(today);
      endDate.setDate(endDate.getDate() + 1); // Add 1 day to include everything up until and including current day
      const payload = {
        startDate: startDate.toISOString(),
        endDate: endDate.toISOString(),
        companyId: Number(companyId),
        groupIds: JSON.parse(myUser?.selectedGroupIds) || JSON.parse(localStorage.getItem(LocalStorageKeys.selectedGroups) || "[]")
      }
      const response = await portalApiClient.post(apiUrls.completion.get.url(), payload as any);
      return response.data;
    }
  })
  return query;
}

export function useCompletionsForNearestDay() {
  const completionsQuery = useCompletionsForNearestWeek();
  return useQuery({
    queryKey: [completionsQuery.dataUpdatedAt],
    queryFn: () => {
      return completionsQuery.data?.filter(c => new Date(c.createdAt).toISOString().split("T")[0] === new Date().toISOString().split("T")[0]) ?? [];
    }
  })
}